import "./index.scss"
export default function countStatisticsWrapper(staticData){
    const createWrapper = ()=>{
        if(staticData && staticData.length){
            return (<div className="mgt15 h80 stWrapper">
                    {staticData.map((item)=>{
                    return <div className="st_item" key={item.key}>
                        <i className={"icon "+item.iconClass}></i>
                        <div className="mgl15 countwrapper">
                            <div className="count">{item.count}</div>
                            <div className="description">{item.desc}</div>
                        </div>
                    </div>
                    })}
            </div>)
        }else{
            return null
        }
    }
    return createWrapper();
}